import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import { login, getSession } from './auth';
import { api } from './api';
import AuthCard from './AuthCard';
import { nextPath } from './savedAlbums';

const Signup = ({ location }) => {
  const next = nextPath(location && location.search);
  const carry = next ? `?next=${encodeURIComponent(next)}` : '';
  const [form, setForm] = useState({ name: '', username: '', email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(!!getSession());

  if (done) return <Redirect to={next || '/user'} />;

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const username = form.username.trim();
    try {
      await api('signup', { ...form, username, name: form.name.trim(), email: form.email.trim() });
      // The account exists now; sign in with it like a normal login.
      await login(username, form.password);
      setDone(true);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Create your account">
      <Form onSubmit={submit}>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group controlId="name">
          <Form.Label>Display name</Form.Label>
          <Form.Control autoFocus maxLength={50} value={form.name} onChange={set('name')} />
        </Form.Group>
        <Form.Group controlId="username">
          <Form.Label>Username</Form.Label>
          <Form.Control autoCapitalize="none" autoCorrect="off" maxLength={30}
            value={form.username} onChange={set('username')} />
          <Form.Text className="text-muted">3-30 letters, numbers, hyphens or underscores.</Form.Text>
        </Form.Group>
        <Form.Group controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control type="email" autoCapitalize="none" value={form.email} onChange={set('email')} />
          <Form.Text className="text-muted">Used to verify your account and reset your password.</Form.Text>
        </Form.Group>
        <Form.Group controlId="password">
          <Form.Label>Password</Form.Label>
          <Form.Control type={showPassword ? 'text' : 'password'} autoComplete="new-password"
            value={form.password} onChange={set('password')} />
          <Form.Text className="text-muted">At least 8 characters.</Form.Text>
          <Form.Check className="mt-2" type="checkbox" label="Show password"
            checked={showPassword} onChange={(e) => setShowPassword(e.target.checked)} />
        </Form.Group>
        <Button type="submit" block disabled={loading}>
          {loading ? 'Creating account…' : 'Create account'}
        </Button>
        <div className="text-center mt-3">Already have an account? <Link to={`/login${carry}`}>Log in</Link></div>
      </Form>
    </AuthCard>
  );
};

export default Signup;
